import React, {createContext, useContext, useEffect, useState, useCallback} from "react";
import {auth} from "../../firebase/firebase.js";
import {onAuthStateChanged} from "firebase/auth";

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userLoggedIn, setUserLoggedIn] = useState(false);
    const [registering, setRegistering] = useState(false);

    const initializeUser = useCallback(async (user) => {
        if (user && !registering) {
            setCurrentUser(user);
            setUserLoggedIn(true);
        } else if (!user) {
            setCurrentUser(null);
            setUserLoggedIn(false);
        }
        if (!registering) {
            setLoading(false);
        }
    }, [registering]);

    function setRegisteringState(isRegistering) {
        setRegistering(isRegistering);
        if (!isRegistering) {
            setLoading(false);
        }
    }

    async function getToken() {
        if (currentUser) {
            try {
                // Force refresh to ensure the token is fresh
                const token = await currentUser.getIdToken(true);
                return token;
            } catch (error) {
                console.error("Error fetching ID token:", error);
                return null;
            }
        }
        return null;
    }

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, initializeUser);
        return unsubscribe;
    }, [initializeUser]);

    const value = {
        currentUser,
        userLoggedIn,
        loading,
        registering,
        setRegisteringState,
        getToken,
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}
